import { Select } from '@arco-design/web-react';
import React from 'react';
import { useFontsStore } from '@/store';

export interface FontSelectionProps {
  className?: string;
  disabled?: boolean;
  value?: string;
  onChange?: (v: string) => void;
}

export function FontSelection(props: FontSelectionProps) {
  const { fonts } = useFontsStore();
  return (
    <Select
      showSearch
      size='small'
      triggerProps={{
        position: 'tl',
        autoAlignPopupWidth: false,
        autoAlignPopupMinWidth: true,
        updateOnScroll: true,
      }}
      {...props}
    >
      <Select.Option value='Noto Sans CJK SC'>思源雅黑</Select.Option>
      {fonts.map((item) => (
        <Select.Option key={item} value={item}>
          {item}
        </Select.Option>
      ))}
    </Select>
  );
}
